import { render, staticRenderFns } from "./StartApplication.vue?vue&type=template&id=afa14bbe&scoped=true&"
import script from "./StartApplication.vue?vue&type=script&lang=js&"
export * from "./StartApplication.vue?vue&type=script&lang=js&"
import style0 from "./StartApplication.vue?vue&type=style&index=0&id=afa14bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa14bbe",
  null
  
)

export default component.exports